export const TAXON_BASICS_DETAILS_SERVER = `
  fragment TaxonBasicDetails on Taxon {
    id
    name
  }
`;
